import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'ia-react-core';
import { useHistory } from 'react-router';
import { ReactComponent as ErrorIcon } from '../../assets/Robot-error.svg';
import {
  StyledActionBar,
  StyledErrorMessage, StyledIcon, StyledParagraph,
  StyledTitle,
  StyledWrapper,
} from '../ErrorPages.styles';
import redirectTo from '../../utils/redirectTo';

export interface UnauthorizedPageProps { }

const UnauthorizedPage: FC<UnauthorizedPageProps> = () => {
  const history = useHistory();
  const { t } = useTranslation('UnauthorizedPage');
  return (

    <StyledWrapper>
      <StyledErrorMessage>
        <StyledIcon as={ErrorIcon} />
        <StyledTitle data-testid="unauthorizedErrorTitle">{t('title')}</StyledTitle>
        <StyledParagraph>
          {t('message')}
        </StyledParagraph>
        <StyledActionBar>
          <PrimaryButton onClick={() => { redirectTo('/', history); }}>{t('technicalErrorButton')}</PrimaryButton>
        </StyledActionBar>
      </StyledErrorMessage>
    </StyledWrapper>
  );
};
export default UnauthorizedPage;
